// JsFromRoutes CacheKey ab67bf6ab85c78f0eae13736a2345ffc
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  create: /* #__PURE__ */ definePathHelper('post', '/:account_id/settings/api-keys'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/:account_id/settings/api-keys/:id'),
}
